import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const updateCartRequest = async (
  productInfo,
  isUserLoggedIn,
  replace,
) => {
  if (isUserLoggedIn) {
    const formattedProductInfo = {
      ...productInfo,
      product: productInfo.product.id,
    };
    const response = await axios.patch(
      `${apiRoutes.USER_CART}${replace ? "?replace=true" : ""}`,
      formattedProductInfo,
    );
    return response.data;
  } else {
    return updateLocalStorageCart(productInfo, replace);
  }
};

export const getUserCart = async (isUserLoggedIn) => {
  if (isUserLoggedIn) {
    const response = await axios.get(apiRoutes.USER_CART);
    return response.data;
  } else {
    return getCartFromLocalStorage();
  }
};

const getCartFromLocalStorage = () => {
  const storedCart = localStorage.getItem("cart");
  if (storedCart) {
    return JSON.parse(storedCart);
  } else {
    const initCart = { cartItems: [] };
    localStorage.setItem("cart", JSON.stringify(initCart));
    return initCart;
  }
};

const updateLocalStorageCart = (productInfo, replace) => {
  const updatedCart = getCartFromLocalStorage();
  const existingItem = updatedCart.cartItems.find(
    (item) => item.product.id === productInfo.product.id,
  );

  if (existingItem) {
    if (productInfo.quantity === 0) {
      return removeFromLocalStorageCart(productInfo);
    }

    existingItem.quantity = replace
      ? parseInt(productInfo.quantity)
      : parseInt(existingItem.quantity) + parseInt(productInfo.quantity);
    // Same semantics as the server cart: undefined leaves the value as is,
    // null clears it.
    if (productInfo.note !== undefined) existingItem.note = productInfo.note;
    if (productInfo.offerPriceCents !== undefined) {
      existingItem.offerPriceCents = productInfo.offerPriceCents;
    }
  } else {
    if (productInfo.quantity !== 0) {
      const formattedProductInfo = {
        ...productInfo,
        quantity: parseInt(productInfo.quantity),
      };
      updatedCart.cartItems.push(formattedProductInfo);
    }
  }

  localStorage.setItem("cart", JSON.stringify(updatedCart));
  localStorage.setItem("hasUnsyncedCartChanges", JSON.stringify(true));
  return updatedCart;
};

const removeFromLocalStorageCart = (productInfo) => {
  const updatedCart = getCartFromLocalStorage();
  updatedCart.cartItems = updatedCart.cartItems.filter(
    (item) => item.product.id !== productInfo.product.id,
  );
  localStorage.setItem("cart", JSON.stringify(updatedCart));
  if (updatedCart.cartItems.length === 0) {
    localStorage.setItem("hasUnsyncedCartChanges", JSON.stringify(true));
  }
  return updatedCart;
};

export const syncLocalStorageCartRequest = async () => {
  const hasUnsyncedCartChanges = localStorage.getItem("hasUnsyncedCartChanges");
  if (hasUnsyncedCartChanges) {
    const localCart = getCartFromLocalStorage();
    const formattedCartItems = localCart.cartItems.map((item) => {
      return { ...item, product: item.product.id };
    });
    const response = await axios.patch(
      apiRoutes.BULK_UPDATE_CART,
      formattedCartItems,
    );
    return response.data;
  }
};
